var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('v-text-field',{key:item.id,attrs:{"type":"text","color":"primary","outlined":"","disabled":"","value":item.full_address}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }